module.exports = __webpack_public_path__ + "eb2e50b1b28be3d0c373e0fe48c105ef.svg";